"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTable = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = require("b2b-components/theme/components/Form/Checkbox/Checkbox");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _key = require("b2b-components/utils/key");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _AddRowButton = require("./AddRowButton");
var _Body = require("./Body");
var _Row = require("./Body/Row");
var _Cell = require("./Body/Row/Cell");
var _Head = require("./Head");
var _Row2 = require("./Head/Row");
var _Cell2 = require("./Head/Row/Cell");
require("./DataTable.scss");
const DataTable = _ref => {
  let {
    addedRows,
    areRowsRemovable,
    breakpoint,
    className,
    createAddButton,
    createDeleteButton,
    currentRowIndexes,
    dataAttributes,
    header,
    isRowAddable,
    onRowMouseEnter,
    onRowMouseLeave,
    rows,
    selectableOptions,
    isHoverable = false,
    isSelectable = false,
    maxRows = Number.MAX_SAFE_INTEGER
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-DataTable', {
    'cds-DataTable--Selectable': isSelectable,
    [`cds-DataTable--MobileBreakpoint${(0, _upperCase.upperCase)(breakpoint || '') || ''}`]: breakpoint,
    'cds-DataTable--Hoverable': isHoverable
  }, className);
  const createRow = (row, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: (0, _key.createKey)(index, 'BodyRow')
  }, /*#__PURE__*/_react.default.createElement(_Row.Row, {
    className: row.className,
    hasSubRow: !!row.subRow,
    onClick: row.onClick,
    onMouseEnter: onRowMouseEnter(row.onMouseEnter, {
      hasSubRow: !!row.subRow
    }),
    onMouseLeave: row.subRow && onRowMouseLeave({
      hasSubRow: true
    })
  }, isSelectable && /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    className: (0, _classnames.default)('cds-DataTable-BodyCell--Checkbox', selectableOptions?.className),
    mobileOrder: 0,
    value: row.selectableValue !== undefined ? /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
      isChecked: selectableOptions && selectableOptions.isOptionChecked(row.selectableValue),
      onChange: () => {
        selectableOptions && selectableOptions.onOptionChange(row.selectableValue);
      }
    }) : null
  }), row.cells.map((cell, index) => /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    className: cell.className,
    key: (0, _key.createKey)(index, 'BodyCell'),
    mobileLabel: header && header[index].mobileLabel,
    mobileOrder: cell.mobileOrder,
    isRowId: cell.isRowId,
    value: cell.value
  })), areRowsRemovable && /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    value: createDeleteButton(index)
  })), row.subRow && /*#__PURE__*/_react.default.createElement(_Row.Row, {
    className: row.className,
    isSubRow: true,
    onClick: row.onClick,
    onMouseEnter: onRowMouseEnter(row.onMouseEnter, {
      isSubRow: true
    }),
    onMouseLeave: onRowMouseLeave({
      isSubRow: true
    })
  }, /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    className: row.subRow ? row.subRow.className : '',
    colspan: isSelectable ? row.cells.length + 1 : row.cells.length,
    value: row.subRow && row.subRow.value || ''
  }), areRowsRemovable && /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    value: ""
  })));
  const isRowNotRemoved = index => currentRowIndexes.includes(index);
  if (!Array.isArray(rows)) {
    return null;
  }
  const bodyRows = rows.reduce((total, row, index) => {
    if (isRowNotRemoved(index) && total.length < maxRows) {
      total.push(createRow(row, index));
    }
    return total;
  }, []);
  const addedBodyRows = addedRows.reduce((total, row, index) => {
    const addedRowIndex = index + rows.length;
    if (isRowNotRemoved(addedRowIndex) && total.length < maxRows - bodyRows.length) {
      total.push(createRow(row, addedRowIndex));
    }
    return total;
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("table", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), header && /*#__PURE__*/_react.default.createElement(_Head.Head, null, /*#__PURE__*/_react.default.createElement(_Row2.Row, null, isSelectable && /*#__PURE__*/_react.default.createElement(_Cell2.Cell, {
    className: "cds-DataTable-HeadCell--Checkbox",
    value: /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
      isChecked: selectableOptions && selectableOptions.isCheckboxChecked,
      isRemoveMode: selectableOptions && selectableOptions.isCheckboxRemoveMode,
      onChange: selectableOptions && selectableOptions.onCheckboxChange
    })
  }), header && header.map((cell, index) => /*#__PURE__*/_react.default.createElement(_Cell2.Cell, {
    className: cell.className,
    key: (0, _key.createKey)(index, 'HeadCell'),
    value: cell.value
  })), areRowsRemovable && /*#__PURE__*/_react.default.createElement(_Cell2.Cell, {
    value: ""
  }))), /*#__PURE__*/_react.default.createElement(_Body.Body, null, bodyRows, addedBodyRows)), isRowAddable && currentRowIndexes.length < maxRows && /*#__PURE__*/_react.default.createElement(_AddRowButton.AddRowButton, {
    button: createAddButton()
  }));
};
exports.DataTable = DataTable;
//# sourceMappingURL=DataTable.js.map